export default __webpack_public_path__ + "static/cr-add-columns-gif-ff10cfdba560ff4ef621c37125f3ef7a.mp4";